module.exports = __webpack_public_path__ + "static/media/bytt-no-9.a823fe1b.mp3";